<template>
    <div>
        <forms
                :settings="settings"
                @onFormButtonClick="onFormButtonClick"
        ></forms>
    </div>
</template>

<script>
import axios from "axios";
import toastr from 'toastr';
import Forms from "@/components/form/Forms";
export default {
    name: "KorisnikForma",
    components:{ Forms },
    props:{
        disabled:{
            type: Boolean,
            default: false
        },
        id:{
            default: null
        },
        modal:{
            type: Boolean,
            default: false
        },
        action: {
            type: String
        }
    },
    data(){
        return {
            settings: {},
            errors: {},
            route: '/korisnici',
            url: 'korisnik',
            data: {}
        }
    },

    methods: {

        init(){
            let vm = this
            if ( vm.action === 'edit' || vm.action === 'show' ){

                axios.get( process.env.VUE_APP_API_URL + vm.url + '/' + vm.id )
                        .then( function ( response ) {
                            vm.data = response.data
                            vm.$emit( 'returnData', response.data )
                            vm.setupForm()
                        } )
                        .catch( function ( error ) {
                            if(error instanceof Error) {
                                console.log( 'Error: ' . error);
                            } else {
                                console.log( 'Unexpected response: ' . error);
                            }
                        } )

            } else if ( vm.action === 'create' ) {
                vm.data = {}
                vm.setupForm()
            } else {
                return
            }
        },

        setupForm(){

            let vm = this;

            vm.buttons = []

            let button_cancel = {
                id: 'cancel',
                title: 'Odustani',
                type: 'warning',
                action: 'redirect', // request
                config: {
                    url: vm.route + ( vm.action === 'edit' ? ( '/' + vm.id) : '' )
                }
            }

            let button_delete = {
                id: 'delete',
                title: 'Obriši',
                type: 'danger',
                action: 'request',
                config: {
                    method: 'DELETE',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let button_edit = {
                id: 'edit',
                title: 'Uredi',
                type: 'success',
                action: 'redirect',
                config: {
                    url: vm.route +  '/' + vm.id +'/edit'
                }
            }

            let button_save = {
                id: 'save',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'POST',
                    url: process.env.VUE_APP_API_URL + vm.url
                }
            }

            let button_update = {
                id: 'update',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'PUT',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let buttons = []


            if( vm.action === 'edit' ){
                buttons.push( button_cancel)
                buttons.push( button_update)
            } else if( vm.action === 'show' ) {
                buttons.push( button_cancel )
                buttons.push( button_delete )
                buttons.push( button_edit )
            }
            else if ( vm.action === 'create' ) {
                buttons.push( button_cancel )
                buttons.push( button_save )
            } else {
                return
            }

            let settings = {
                width: 6,
                modal: false,
                tabs:[
                    {
                        name: '',
                        active: true,
                        sections: [
                            {
                                name: '',
                                width: 12,
                                inputs: [
                                    {
                                        name: 'ime',
                                        type: 'input',
                                        title: 'Ime',
                                        value: vm.data['ime'] ? vm.data['ime'] : '',
                                        width: 12,
                                        error: vm.errors['ime'] ? vm.errors['ime'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {} // email = true || password = true
                                    },
                                    {
                                        name: 'prezime',
                                        type: 'input',
                                        title: 'Prezime',
                                        value: vm.data['prezime'] ? vm.data['prezime'] : '',
                                        width: 12,
                                        error: vm.errors['prezime'] ? vm.errors['prezime'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'oib',
                                        type: 'input',
                                        title: 'OIB',
                                        value: vm.data['oib'] ? vm.data['oib'] : '',
                                        width: 12,
                                        error: vm.errors['oib'] ? vm.errors['oib'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled || vm.action === 'edit',
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {} // email = true || password = true
                                    },
                                    {
                                        name: 'email',
                                        type: 'input',
                                        title: 'E-mail',
                                        value: vm.data['email'] ? vm.data['email'] : '',
                                        width: 12,
                                        error: vm.errors['email'] ? vm.errors['email'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {
                                            'email': true
                                        }
                                    },
                                    {
                                        name: 'password',
                                        type: 'input',
                                        title: 'Lozinka',
                                        value: vm.data['password'] ? vm.data['password'] : '',
                                        width: 12,
                                        error: vm.errors['password'] ? vm.errors['password'] : '',
                                        note: vm.action === 'edit' ? 'Ako ne želite mijenjati password ostavite prazno' : '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {
                                            'password': true
                                        }
                                    },
                                    {
                                        name: 'password_confirm',
                                        type: 'input',
                                        title: 'Ponovi lozinku',
                                        value: vm.data['password_confirm'] ? vm.data['password_confirm'] : '',
                                        width: 12,
                                        error: vm.errors['password_confirm'] ? vm.errors['password_confirm'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {
                                            'password': true
                                        }
                                    },
                                    {
                                        name: 'confirmed',
                                        type: 'select',
                                        title: 'Potvrđen račun',
                                        value: {
                                            key: (vm.data['confirmed']) ? "1" : "0",
                                            value: (vm.data['confirmed']) ? "Da" : "Ne"
                                        },
                                        width: 12,
                                        error: vm.errors['confirmed'] ? vm.errors['confirmed'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {
                                            options: [
                                                {
                                                    key: "1",
                                                    value: "Da"
                                                },
                                                {
                                                    key: "0",
                                                    value: "Ne"
                                                }
                                            ],
                                            multiple: false,
                                        }
                                    }
                                ],
                            }
                        ],
                    },
                ],
                buttons: buttons
            }

            vm.settings = settings
        },

        /**
         *  on input return data
         */
        // onInput( name, value ){
        //     console.log( 'AdministratorForma input -> ' + name + ':' , value )
        // },

        /**
         *  on button click
         */
        onFormButtonClick( id, action, config, data  ){

            if( id === 'save' || id === 'update' ){
                if( data.success){
                    if( id == 'save' )
                        toastr.success( 'Uspješno spremljeno!' )
                    else if ( id == 'update' )
                        toastr.success( 'Uspješno ažurirano!' )
                    this.$router.push({ path: this.route + '/' + data.data.id } )
                } else {
                    this.errors = data.messages
                    this.init()
                }
            } else if( id == 'delete' ){
                toastr.error( 'Uspješno obrisano!' )
                this.$router.push({ path: this.route } )
            }

        },


    },
    mounted() {
        this.init()
    }
}
</script>

<style scoped>

</style>